import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputComponent } from './input.component';
import { IconModule } from '../icon/icon.module';
import { FormsModule } from '@angular/forms';
import { InputDirective } from './input.directive';
import { LabelModule } from '../label/label.module';
import { MessageModule } from '../message/message.module';
import { StackModule } from '../stack/stack.module';

@NgModule({
  declarations: [InputComponent, InputDirective],
  imports: [CommonModule, IconModule, FormsModule, LabelModule, MessageModule, StackModule],
  exports: [InputComponent, InputDirective],
  schemas: [NO_ERRORS_SCHEMA],
})
export class InputModule {}
